/**
 * Місце екрана в рядку застосунку (layout.md, розд. 7, правило 6): між пошуком і іконками верхньої
 * панелі. Картка ставить сюди шлях і «8 з 86 ‹ ›», тож її верх — два рядки, а не три (≤ 125 px).
 *
 * Оболонка тримає елемент слота в стані (`ref`-колбек `Topbar`) і віддає його контекстом; екран
 * малює вміст порталом. Поки слота немає (перший рендер оболонки) — нічого: висота панелі стала,
 * тож пізня поява вмісту не зсуває сторінку. Поза оболонкою (тести окремих частин) — теж нічого.
 */
import { createContext, type ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

export const TopbarSlotContext = createContext<HTMLElement | null>(null);

export function TopbarSlot({ children }: { children: ReactNode }) {
  const slot = useContext(TopbarSlotContext);
  return slot ? createPortal(children, slot) : null;
}
